
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        const isDesktop = window.innerWidth > 1024;
        $( '.primary-nav' ).slideToggle();

        if ( isDesktop ) {
          $( '#ll-body' ).toggleClass( 'is-open-parent is-open' );
        } else {
          $( '#ll-body' ).removeClass( 'is-open' );
        }
      } );

      $( '.children-item__children' ).on( 'toggleAfter', ( event ) => {
        updateMenuIndex( event.target );
        firstLinkFocus( event.target );
      } );

      /* Navigation logo animation */
      const svgs = document.querySelectorAll( '.header__logo, .footer__logo' );

      svgs.forEach( ( svg ) => {
        const paths = svg.querySelectorAll( '.logo__svg-path' );

        paths.forEach( ( path ) => {
          const length = path.getTotalLength();

          path.style.strokeDasharray = length;
          path.style.strokeDashoffset = '0';
          path.style.opacity = '1';

          svg.addEventListener( 'mouseenter', function() {
            path.style.transition = 'opacity 150ms ease-out, stroke-dashoffset 0s ease-in-out';
            path.style.opacity = '0';

            setTimeout( () => {
              path.style.strokeDashoffset = length;

              setTimeout( () => {
                path.style.opacity = '1';
              }, 0 );

              setTimeout( () => {
                path.style.transition = 'stroke-dashoffset 1.5s ease-in-out';
                path.style.strokeDashoffset = '0';
              }, 50 );
            }, 150 );
          } );

          // svg.addEventListener( 'mouseleave', function() {
          //   path.style.transition = 'none';
          //   path.style.opacity = '1';
          //   path.style.strokeDashoffset = '0';
          // } );
        } );
      } );

      /* ADA close the nav if you have tabbed outside it on mobile */
      const ctaLink = $( '.nav__cta-banner-link' );

      $( '#primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget === null || window.innerWidth > 1024 ) return;
        const reltarget = $( event.relatedTarget );
        const currenttarget = $( event.currentTarget );

        if ( !reltarget.closest( '#primary-nav' ).is( currenttarget ) && ( $( reltarget ).get( 0 ) !== $( '.navbar-toggle' ).get( 0 ) ) ) {
          $( '.navbar-toggle' ).trigger( 'click' );
        }
      } );

      $( '.primary-menu-item > button' ).on( 'toggleAfter', function( e ) {
        if ( window.innerWidth >= 1024 ) {
          const menu = $( e.target ).attr( 'data-menu' );
          $( menu ).fadeToggle( 250 );
        }
      } );

      $( '#sub-nav li button' ).on( 'click', function( e ) {
        updateDropdownHeight();
      } );

      $( window ).on( 'resize', function() {
        updateDropdownHeight();
      } );

      $( '#nav-overlay' ).on( 'click', function() {
        $( '#dropdown-behind' ).addClass( 'hidden' );
      } );

      function updateDropdownHeight() {
        if ( window.innerWidth <= 1024 ) {
          $( '#dropdown-behind' ).css( 'height', '' ).addClass( 'hidden' );
          return;
        }

        if ( $( '.primary-nav .dropdown-menu.is-open' ).length > 0 ) {
          let maxHeight = 0;

          $( '.primary-nav .dropdown-menu.is-open' ).each( function() {
            maxHeight = Math.max( maxHeight, $( this ).outerHeight() );
          } );

          $( '#dropdown-behind' ).css( 'height', maxHeight + 'px' ).removeClass( 'hidden' );
        } else {
          $( '#dropdown-behind' ).css( 'height', '' ).addClass( 'hidden' );
        }
      }

      // $( '.primary-nav .dropdown-menu li button' ).on( 'toggleAfter', function( e ) {
      //   if ( window.innerWidth >= 1024 ) {
      //     const menu = $( e.target ).attr( 'data-menu' );
      //     $( menu ).fadeToggle( 250 );
      //   }
      // } );

      const updateBannerHeight = () => {
        if ( $( '.primary-nav-mobile-cta' ).length > 0 ) {
          const ctaBannerHeight = $( '.primary-nav-mobile-cta' ).outerHeight();
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      if ( window.matchMedia( '(max-width: 1024px)' ).matches ) {
        $( '.children-item__children.is-open-parent' ).trigger( 'click' );
      }

      function handleLargeChange( event ) {
        if ( event.matches ) {
          updateBannerHeight();
        }
        if ( !event.matches && ( $( '.children-item__children.is-open-parent' ).length === 0 ) ) {
          $( '.children-item__children[data-toggle-is-active]' ).trigger( 'click' );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const largeSize = window.matchMedia( '(max-width: 1024px)' );
      largeSize.addEventListener( 'change', handleLargeChange );
      handleLargeChange( largeSize );

      /* end of navigation js */

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        // get the title from data attribute added to button
        // console.log( .data( 'title' ) );
        const title = $( e.target ).data( 'title' );
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          focus: '.mfp-close',
          closeBtnInside: true,
          autoFocusLast: true,
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              // get the current instance of the magnificPopup
              const currentMagnificPopup = $.magnificPopup.instance;

              // add title to the container aria label
              currentMagnificPopup.contentContainer.attr( 'role', 'dialog' );

              if ( title !== undefined ) {
                // get the current iframe element
                const currIframe = currentMagnificPopup.currTemplate.iframe.find( 'iframe' );
                // add title to the iframe and container
                currIframe.prop( 'title', title );
                currentMagnificPopup.contentContainer.attr( 'aria-label', `${title} player` );
              }

              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.mec-breadcrumbs' ).length > 0 ) {
        const updateBreadCrumbHeight = function() {
          const $breadCrumbHeight = $( '.mec-breadcrumbs' ).outerHeight();
          $( ':root' ).css( '--liftedMecBreadCrumbHeight', $breadCrumbHeight + 'px' );
        };
        updateBreadCrumbHeight();
        const throttledUpdateBreadCrumbHeight = new app.components.common.Throttle( updateBreadCrumbHeight, 250 );
        $( window ).on( 'resize', function() {
          throttledUpdateBreadCrumbHeight.run();
        } );
      }

      /* Primary button */
      $( '.btn-primary, .btn-primary-white, .single_add_to_cart_button, .ll-wocommerce .button, .button.wc-forward, .restore-item, .woocommerce-form-coupon .form-row-last button, .lost_reset_password .woocommerce-Button, .woocommerce-MyAccount-content a.button, .woocommerce button.button, .bag_sidebar-link a, .mec-nextprev-next-button, .mec-events-button' )
          .on( 'mouseenter', function( e ) {
            if ( window.hasMotion ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
              $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
            }
          } )
          .on( 'mouseout', function( e ) {
            if ( window.hasMotion ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
              $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
            }
          } );

      /* ADA - make sure image link is not in tab index since we are using title like to make whole card clickable */
      $( '.mec-event-image a' ).each( function() {
        $( this ).attr( 'tabindex', -1 );
      } );

      // disable duplicate entries on form submit
      $( document ).on( 'submit', '.form-skin', function() {
        // Disable submit button
        $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.throttlePause = false;
      }
      run() {
        if ( this.throttlePause ) return;
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( () => {
          this.callback();
          this.throttlePause = false; // Reset throttle pause state after callback execution
        }, this.time );
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
